// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import service from './service/service'
import md5 from 'js-md5';

Vue.prototype.$md5 = md5;
Vue.prototype.$service = service
Vue.config.productionTip = false
import {codetoken} from './service/fetch'
// codetoken()

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// 动态修改meta搜索引擎
import Meta from 'vue-meta'
Vue.use(Meta)

// 解决跳转页面不是最上面
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
// sessionStorage.setItem('uid', '8')
// 路由变化时
router.beforeEach((to, from, next) => {
  // if(sessionStorage.getItem("data")){codetoken()}
  if(to.meta.title){
    document.title = to.meta.title
  }
  if (to.meta.loAuth) {   //如果需要跳转 ，往下走（1）
    if (JSON.parse(sessionStorage.getItem("data"))) {   //判断是否登录过，如果有登陆过，说明有token,或者token未过期，可以跳过登录（2）
      if (to.path === '/') { //判断下一个路由是否为要验证的路由（3）
        next('/');   // 如果是直接跳到首页，
      } else {    //如果该路由不需要验证，那么直接往后走
        next();
      }
    } else {
      console.log('没有');  //如果没有登陆过，或者token 过期， 那么跳转到登录页
      next('/');
    }
  } else {       //不需要跳转，直接往下走
    next();
  }
  
});
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title;

//   }
//   if (to.meta.loAuth) {   //如果需要跳转 ，往下走（1）
//     if (JSON.parse(sessionStorage.getItem("data"))) {   //判断是否登录过，如果有登陆过，说明有token,或者token未过期，可以跳过登录（2）
//       if (to.path === '/') { //判断下一个路由是否为要验证的路由（3）
//         next('/');   // 如果是直接跳到首页，
//       } else {    //如果该路由不需要验证，那么直接往后走
//         next();
//       }
//     } else {
//       console.log('没有');  //如果没有登陆过，或者token 过期， 那么跳转到登录页
//       next('/');
//     }
//   } //else {       //不需要跳转，直接往下走
//   //   next();
//   // }
//   if(sessionStorage.getItem("data")){codetoken()}
//   // next()
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js